/**
 * Manifest content for homepage - default and circle-specific.
 * When no circle is selected, default content is shown.
 * When a circle is selected, circle-specific content is displayed.
 */

export const DEFAULT_MANIFESTO = {
  heading: 'حيث تتلاقى الدوائر',
  paragraph: 'منصّة إلكترونية تهدف إلى إثراء المحتوى الثقافي العربي، وإعطاء المبدعين مساحة آمنة -ومنطقية بعض الشيء- للتعبير عن ذواتهم وسط فضاء الدوت كوم الشاسع.',
  tagline: 'أبدِع كي لا تكون وحيدًا!'
};

/**
 * Circle-specific manifest content.
 * Keys match circle slugs from the API.
 * Structure: { title, description?, quote?, author? }
 */
export const CIRCLE_MANIFEST_CONTENT = {
  literature: {
    title: 'دائرة الأدب',
    quote: '«يمكن تحمُّل كل الأحزان إذا وضعتها في قصة، أو رويْتَ قصةً عنها.»',
    author: 'كارين بلكسين'
  },
  poetry: {
    title: 'دائرة الشعور',
    quote: '«وَمَا الدّهْرُ إلاّ مِنْ رُواةِ قَصائِدي            إذا قُلتُ شِعرًا أصْبَحَ الدّهرُ مُنشِدَا»',
    author: 'أبو الطيّب المتنبّي'
  },
  'classical-poetry': {
    title: 'الشعر الفصيح',
    quote: '«قد ضُمِّنَ الدُرَّ إلّا أنَّهُ كَلِمُ»',
    author: 'أبو الطيّب المتنبّي'
  },
  'modern-poetry': {
    title: 'الشعر الحديث',
    quote: '«شاعرٌ يتمشّى في هواجسه»',
    author: 'محمود درويش'
  },
  'colloquial-poetry': {
    title: 'شعر العاميّة',
    quote: '«ألفين سنة ويفضل كلامي جميل»',
    author: 'فؤاد حداد'
  },
  soul: {
    title: 'دائرة النَفْس',
    quote: '«من ينظر إلى الخارج يحلُم، ومن ينظر إلى الداخل يستيقظ»',
    author: 'كارل يونج'
  },
  visuals: {
    title: 'دائرة العين',
    description: 'قسمٌ معنيٌ بكافة أشكال الإبداع المرئي، لأن الرؤية تسبِقُ كلَ شيء.'
  },
  sound: {
    title: 'دائرة الصوت',
    description: 'قسمٌ معنيٌ بالموسيقى والصوتيات.',
    quote: '«والأذنُ تعشقُ قبل العينِ أحيانًا»',
    author: 'بشّار بن برد'
  },
  philosophy: {
    title: 'دائرة العقل',
    description: 'لا تعطي الفلسفة أجوبةً نهائية، ولكنّها تعلّمنا حكمة ألا ننخدع بالكلام.'
  },
  heritage: {
    title: 'دائرة التراث',
    description: 'اتكئ على ماضيك وامضِ إلى الأمام.'
  },
  arts: {
    title: 'دائرة الفنون',
    quote: '«هَزَمَتْكَ يا موتُ الفنونُ جميعُها»',
    author: 'محمود درويش'
  },
  language: {
    title: 'دائرة اللسان',
    description: 'قسمٌ معنيٌ بالترجمات، وعلوم اللغات وتراكيبها.'
  },
  journey: {
    title: 'دائرة الرحلة',
    description: 'تأملات لأصحابها'
  },
  sufism: {
    title: 'دائرة الدائرة',
    description: 'قسمٌ معنيٌ بالتصوّف.',
    quote: '«افتح عينك؛ فما ثم إلا وجودٌ مستمر، وشهودٌ ثابتٌ مستقر»',
    author: 'محيي الدين بن عربي'
  }
};

export const getManifestContent = (activeCircle) => {
  if (!activeCircle || activeCircle === 'all') {
    return { type: 'default', ...DEFAULT_MANIFESTO };
  }
  const content = CIRCLE_MANIFEST_CONTENT[activeCircle];
  if (!content) {
    return { type: 'default', ...DEFAULT_MANIFESTO };
  }
  return { type: 'circle', ...content };
};
